import { render } from "./DeliveryPicker.vue?vue&type=template&id=2b8f3694"
import script from "./DeliveryPicker.vue?vue&type=script&lang=js"
export * from "./DeliveryPicker.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DeliveryPicker.vue?vue&type=style&index=0&id=2b8f3694&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__